// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-overlay[data-v-6ca3d9b4]:hover{color:#2fa4e5!important}", ""]);
// Exports
module.exports = exports;
